import {IFileDetailsStoreState} from './IFileDetailsStoreState';

export const fileDetailsInitialState: IFileDetailsStoreState = {
  page: {
    loading: false,
    fileDownloading: false,
  },
  fileDetails: null,
};
